import { useNodeConnections } from '@xyflow/react';
import { MemoryPrimitive } from './primitive';
import { MemoryTransform } from './transform';

export type MemoryNodeProps = {
  type: string;
  data: {
    content?: string;
    tags?: string[];
    generated?: {
      memoryId?: string;
      status?: string;
      error?: string;
      result?: string;
      savedAt?: string;
      metadata?: {
        type: string;
        model: string;
        category: string;
        created_by: string;
        created_at: string;
      };
    };
    updatedAt?: string;
  };
  id: string;
};

export const MemoryNode = (props: MemoryNodeProps) => {
  const connections = useNodeConnections({
    id: props.id,
    handleType: 'target',
  });
  const Component = connections.length ? MemoryTransform : MemoryPrimitive;

  return <Component {...props} title="Memory" />;
};
